module.exports = __webpack_public_path__ + "img/632.66bdd23d.jpg";